import { render, staticRenderFns } from "./transForm.vue?vue&type=template&id=1ae116da&scoped=true"
import script from "./transForm.vue?vue&type=script&lang=js"
export * from "./transForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae116da",
  null
  
)

export default component.exports